var GALLERY_IMAGE_HEIGHT = 200;
var GALLERY_IMAGE_WIDTH = 300;
export var getGridSize = function(numSecondaryImages) {
    if (numSecondaryImages === 0) {
        return {
            columns: "1fr",
            rows: "1fr"
        };
    }
    if (numSecondaryImages === 1) {
        return {
            columns: "1fr 1fr",
            rows: "1fr"
        };
    }
    return {
        columns: "2fr 1fr",
        rows: "1fr 1fr"
    };
};
var getMainAndSecondaryImageWidthRatios = function(numSecondaryImages) {
    if (numSecondaryImages === 0) {
        return [
            1,
            0
        ];
    }
    if (numSecondaryImages === 1) {
        return [
            1 / 2,
            1 / 2
        ];
    }
    return [
        2 / 3,
        1 / 3
    ];
};
var getSecondaryImageHeightRatio = function(numSecondaryImages) {
    if (numSecondaryImages === 0) {
        return 0;
    }
    if (numSecondaryImages === 1) {
        return 1;
    }
    return 1 / 2;
};
export var getMainImageDimensions = function(numSecondaryImages) {
    return {
        width: GALLERY_IMAGE_WIDTH * getMainAndSecondaryImageWidthRatios(numSecondaryImages)[0],
        height: GALLERY_IMAGE_HEIGHT
    };
};
export var getSecondaryImageDimensions = function(numSecondaryImages) {
    return {
        width: GALLERY_IMAGE_WIDTH * getMainAndSecondaryImageWidthRatios(numSecondaryImages)[1],
        height: GALLERY_IMAGE_HEIGHT * getSecondaryImageHeightRatio(numSecondaryImages)
    };
};
